module.exports = "<div class=\"bg\" [ngClass]=\"bgClass\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/bg/bg.component.html
// module id = 461
// module chunks = 0